import * as types from '@/store/mutationTypes';
import API from '@/api';
import _ from 'lodash';

const state = {
  siteDesignation: {
    designationCode: 'ltn-na',
    plugins: {
      hq: {
        privacy_policy: 'https://www.livestocktransportnation.com/privacy-policy?cleanMode=true',
        contact_info: {
          contact_us_href: 'https://www.livestocktransportnation.com/contact-us',
          site_corner_image: '/static/ltn_transparent.png',
        },
      },
      locality: {
        lang: 'en',
        country: 'US',
        locale: 'en-US',
        load_map: {
          center: {
            // this is the center of the US to have an initial value
            lat: 37.090240,
            lng: -95.712891,
          },
        },
        is_usa: true,
      },
      loadboard: {
        enabled: true,
        states: [],
        // TODO: let's make this true by default before we finish
        enableBidding: false,
      },
    },
  },
};

const getters = {
  siteDesignation: appState => _.get(appState, 'siteDesignation', null),
};

const mutations = {
  [types.SET_SITE_DESIGNATION](designationState, designation) {
    // eslint-disable-next-line no-param-reassign
    designationState.siteDesignation = designation; // eslint-disable-line no-param-reassign
  },
};

const actions = {
  async loadSiteDesignation({ commit }) {
    // once this is done over API, await this bad boy
    const response = API.siteDesignation.loadSiteDesignation();
    commit(types.SET_SITE_DESIGNATION, response.data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/plugins.js